import * as React from 'react';

const UnorderedListChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            id="unordered-list-chunky_svg__eds-icon--unordered-list-chunky_svg"
            d="M4 5h2v2H4V5zm0 6h2v2H4v-2zm0 6h2v2H4v-2zM8 5h12v2H8V5zm0 6h12v2H8v-2zm0 6h12v2H8v-2z"
        />
    </svg>
);

UnorderedListChunkySvg.displayName = 'UnorderedListChunkySvg';
export default UnorderedListChunkySvg;
